import { RouteObject } from 'react-router-dom';

import ErrorPage from '~components/errorBoundary/errorPage';
import ErrorType from '~components/errorBoundary/errorType';
import { pagePathSegments } from '~constants';
import { LoginCallbackPage, LoginLaunchPage, LogoutPage, SilentCallbackPage } from '~features/auth';
import HomePage from '~features/home/homePage';
import { UserDetailsPage } from '~features/users';
import { MainLayout } from '~layouts';

import ProtectedRoute from './components/protectedRoute';
import PublicRoute from './components/publicRoute';
import RouteErrorElement from './components/routeErrorElement';
import devicegroupRoutes from './deviceGroupRoutes';
import devicesRoutes from './devicesRoutes';
import keygroupRoutes from './keyGroupRoutes';
import keysRoutes from './keysRoutes';
import organisationsRoutes from './organisationsRoutes';
import userRoutes from './userRoutes';
import WebhookRoutes from './webhookRoutes';
import wikiRoutes from './wikiRoutes';

const Routes = (): RouteObject[] => {
	return [
		{
			path: pagePathSegments.Auth,
			element: <PublicRoute />,
			errorElement: <RouteErrorElement />,
			children: [
				{
					path: pagePathSegments.Login,
					element: <LoginLaunchPage />,
				},
				{
					path: pagePathSegments.Silent,
					element: <SilentCallbackPage />,
				},
				{
					path: pagePathSegments.Callback,
					element: <LoginCallbackPage />,
				},
			],
		},
		{
			path: pagePathSegments.Logout,
			element: <LogoutPage />,
			errorElement: <RouteErrorElement />,
		},
		{
			element: <MainLayout />,
			errorElement: <RouteErrorElement />,
			children: [
				{
					element: <ProtectedRoute />,
					children: [
						{
							path: pagePathSegments.Home,
							element: <HomePage />,
						},
						{
							path: pagePathSegments.Profile,
							element: <UserDetailsPage showCurrentUser />,
						},
						...devicesRoutes(),
						...devicegroupRoutes(),
						...keysRoutes(),
						...keygroupRoutes(),
						...organisationsRoutes(),
						...userRoutes(),
						...wikiRoutes(),
						...WebhookRoutes(),
					],
				},
				{
					path: '*',
					element: <ErrorPage type={ErrorType.NotFound} />,
				},
			],
		},
	];
};

export default Routes;
